import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import MetaPixel from "./MetaPixel";
import MobileAppLanding from "./MobileAppLanding";
import LandingPage from "./LandingPage";
import LegalPage from "./legal/LegalPage";
import { privacyDoc } from "./legal/privacyContent";
import { termsDoc } from "./legal/termsContent";

function App() {
  return (
    <Router>
      {/* Loads the Meta Pixel — but only after the visitor has explicitly
          accepted marketing tracking — and owns PageView for the landing
          document and every client-side route change after it. Nothing is in
          public/index.html any more; see CONSENT_INTEGRATION.md. */}
      <MetaPixel />
      {/* There is no consent banner and, since the waitlist dialog was
          retired, nothing on the site asks for marketing consent, so the gate
          above stays shut. The footer's Cookie Settings control withdraws a
          consent given earlier. */}
      <Routes>
        {/* The mobile app is the front door; the behaviour-intelligence
            platform page now lives one click away at /platform. */}
        <Route path="/" element={<MobileAppLanding />} />
        <Route path="/platform" element={<LandingPage />} />
        {/* Long-form legal documents. Same shell, different content. */}
        <Route path="/privacy" element={<LegalPage doc={privacyDoc} />} />
        <Route path="/terms" element={<LegalPage doc={termsDoc} />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
